import React, { useEffect, useRef, useState } from 'react'
import { Button } from '@mui/material'
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { CCol, CForm, CFormCheck, CFormInput, CFormLabel, CFormTextarea, CInputGroup, CInputGroupText, CRow } from '@coreui/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Icon } from '@iconify/react'
import { useAuth } from '../contexts/AuthContext';
import { useProduct } from '../contexts/ProductContext';
import { useCompanySetting } from '../contexts/CompanySettingContext';
import CInput from './CInput';
import CSelect from './CSelect';
import CategorySelection from './CategorySelection';
import ModifierSelection from './ModifierSelection';
import IngredientSelection from './IngredientSelection';

const productTypes = [
    { value: "normal", label: "Normal" },
    { value: "open_price", label: "Open" }
]

let unitOptions = [
    { value: "kg", label: "kg" },
    { value: "ml", label: "ml" },
    { value: "liter", label: "Liter" },
    { value: "gram", label: "Gram" },
    { value: "piece", label: "Piece" },
]

const AddProduct = ({ productDetails, editMode, editProductId, setEditProductId, setEditMode, productVisible, setProductVisible, setProductDetails, fetchProducts, canCreate, canUpdate, canDelete }) => {
    const { createProduct, getSingleProduct, deleteProduct, updateProduct, getProductByName, generateSKU } = useProduct()
    const { toast, restaurantId } = useAuth()
    const { currency } = useCompanySetting()
    const dialogContentRef = useRef(null);

    const [ingredientNameValidated, setIngredientNameValidated] = useState(false)
    const [categoryValidated, setCategoryValidated] = useState(false)
    const [validated, setValidated] = useState(false);
    const [ingredientValidated, setIngredientValidated] = useState(false);
    const [visibleAdvancedOptions, setVisibleAdvancedOptions] = useState(false)
    const [ingredientVisible, setIngredientVisible] = useState(false)
    const [editIngredientVisible, setEditIngredientVisible] = useState(false)
    const [ingridientListData, setIngridientListData] = useState([]);
    const [newIngredient, setNewIngredient] = useState({
        id: null,
        quantity: "",
        unit: "",
    })

    useEffect(() => {
        fetchSingleProduct();
    }, [editMode, editProductId]);

    useEffect(() => {
        if (productVisible) {
            fetchSingleProductSkuByName();
        }
    }, [productDetails.name, productVisible]);

    const updateIngridientList = (ingirdient) => {
        if (ingirdient?.unit === 'kg' || ingirdient?.unit === 'gram') {
            unitOptions = [
                { value: "kg", label: "kg" },
                { value: "gram", label: "Gram" },
            ]
        } else if (ingirdient?.unit === 'liter' || ingirdient?.unit === 'ml') {
            unitOptions = [
                { value: "ml", label: "ml" },
                { value: "liter", label: "Liter" },
            ]
        } else if (ingirdient?.unit === 'piece') {
            unitOptions = [
                { value: "piece", label: "Piece" },
            ]
        }
    }

    useEffect(() => {
        setIngridientListData(productDetails?.ingredients);
    }, [productDetails?.ingredients, ingredientVisible]);

    const fetchSingleProduct = async () => {
        if (editProductId) {
            const product = await getSingleProduct(editProductId)

            setIngridientListData(product.ingrediants)
            setProductDetails({
                ...product
            });
        }
    }

    const fetchSingleProductSkuByName = async () => {
        if (productDetails.name.length >= 2 && productVisible) {
            if (!productDetails.sku) {
                const productSKU = await generateSKU(productDetails)
                if (productDetails.name && productSKU && productSKU.sku.length === 8) {
                    setProductDetails({
                        ...productDetails,
                        sku: productSKU.sku
                    });
                }
            }
        } else {
            setProductDetails({
                ...productDetails,
                sku: ''
            })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if ((editMode && !canUpdate) || (!editMode && !canCreate)) return;

        const form = e.currentTarget;
        setValidated(true);
        productDetails.category_id ? setCategoryValidated(false) : setCategoryValidated(true)

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (productVisible && restaurantId && productDetails.category_id) {

                    const selectedModifiers = productDetails.modifiers.length > 0 ? productDetails.modifiers.map(modifier => modifier.value) : []
                    const selectedCategory = productDetails.category_id.value

                    const data = await createProduct({ ...productDetails, restaurant_id: restaurantId, modifiers: selectedModifiers, category_id: selectedCategory })
                    if (!data.error) {
                        fetchProducts(data.product)
                        handleClose();
                    }
                } else if (editMode && editProductId && restaurantId && productDetails.category_id) {

                    const selectedModifiers = productDetails.modifiers.length > 0 ? productDetails.modifiers.map(modifier => modifier.value) : []
                    const selectedCategory = productDetails.category_id.value

                    const data = await updateProduct(editProductId, { ...productDetails, restaurant_id: restaurantId, modifiers: selectedModifiers, category_id: selectedCategory });
                    if (!data.error) {
                        handleClose();
                        fetchProducts()
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleIngredientClose = () => {
        setEditIngredientVisible(false)
        setIngredientVisible(false)
        setIngredientValidated(false)
        setIngredientNameValidated(false)
        setNewIngredient({
            id: null,
            quantity: "",
            unit: ""
        })
    }

    const handleIngredientSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setIngredientValidated(true);
        newIngredient.id ? setIngredientNameValidated(false) : setIngredientNameValidated(true)

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (ingredientVisible && newIngredient.id) {
                    const isexistingIngridient = ingridientListData && ingridientListData?.filter((p) => p.id.value === newIngredient.id.value)
                    if (isexistingIngridient.length > 0) {
                        toast.current?.show({ severity: 'error', summary: 'Item', detail: "Ingridient already created.", life: 3000 })
                    } else if (isexistingIngridient.length === 0 && newIngredient.id && newIngredient.quantity !== 0) {
                        setProductDetails({ ...productDetails, ingredients: [...productDetails.ingredients, newIngredient] })
                        handleIngredientClose(false)
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Item', detail: "Please fill all fields.", life: 3000 })
                    }
                } else if (editIngredientVisible && newIngredient.id) {
                    if (newIngredient.id && newIngredient.quantity > 0) {
                        const existingIngrediantDetail = productDetails.ingredients.filter((i) => i.id.value !== newIngredient.id.value)
                        setProductDetails({ ...productDetails, ingredients: [...existingIngrediantDetail, newIngredient] })
                        handleIngredientClose(false)
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Item', detail: "Please fill all fields.", life: 3000 })
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleClose = () => {
        setProductVisible(false);
        setEditMode(false);
        setEditProductId(null);
        setProductDetails({
            name: '',
            sku: '',
            kitchen_name: '',
            category_id: '',
            price: '',
            cost_price: '',
            modifiers: [],
            color: '#000000',
            image: '',
            refund: "",
            visible: "",
            product_type: "",
            barcode: "",
            description: "",
            enable: "",
            type: "food",
            ingredients: [],
            restaurant_id: restaurantId
        });
    };

    const confirmDelete = async () => {
        return new Promise((resolve) => {
            confirmDialog({
                message: 'Are you sure you want to archive this product?',
                header: 'Archive Confirmation',
                icon: 'pi pi-info-circle',
                position: 'top',
                accept: () => resolve(true),
                reject: () => resolve(false),
            });
        });
    };

    const handleDelete = async () => {
        try {
            const confirmed = await confirmDelete();

            if (confirmed) {
                await deleteProduct(editProductId);
                handleClose();
                fetchProducts()
            }
        } catch (error) {
            console.error('Error during delete operation', error);
        }
    }

    const handleIngredientDelete = (id) => {
        const ingrediants = productDetails.ingredients.filter((i) => i.id !== id)
        setProductDetails({ ...productDetails, ingredients: ingrediants })
    }

    const handleEditIngrediants = (id) => {
        setEditIngredientVisible(true)
        const existingIngrediantDetail = productDetails.ingredients.filter((i) => i.id === id)
        let { id: ingrediantId, quantity, unit } = existingIngrediantDetail[0]
        setNewIngredient({
            id: ingrediantId,
            quantity,
            unit
        })
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProductDetails({ ...productDetails, image: reader.result })
            };
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
        if (visibleAdvancedOptions && dialogContentRef.current) {
            dialogContentRef.current.scrollTop = 0;
        }
    }, [visibleAdvancedOptions]);


    return (
        <>
            <ConfirmDialog />
            {(ingredientVisible || editIngredientVisible) && (
                <Dialog draggable={false} header='Ingredient' visible={ingredientVisible || editIngredientVisible} style={{ width: '29vw' }} onHide={handleIngredientClose}>
                    <CForm onSubmit={handleIngredientSubmit} noValidate validated={ingredientValidated}>
                        <div className='fields-container'>
                            <CRow className="mb-4 mt-3">
                                <IngredientSelection
                                    className='d-flex'
                                    labelClassName='w-50'
                                    value={newIngredient.id}
                                    onChange={(value) => {
                                        updateIngridientList(value)
                                        setNewIngredient({ ...newIngredient, id: value })
                                    }
                                    }
                                    required={true}
                                    multiSelect={false}
                                    disabled={editIngredientVisible}
                                    error={ingredientNameValidated}
                                />
                            </CRow>
                            <CRow className="mb-4">
                                <CCol lg={4}>
                                    <CFormLabel className="form-label w-55">Quantity <span className="text-danger">*</span></CFormLabel>
                                </CCol>
                                <CCol lg={8} className='ps-0'>
                                    <CFormInput
                                        type="number"
                                        step="any"
                                        min={0}
                                        value={newIngredient.quantity}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            if (newValue >= 0) {
                                                setNewIngredient({ ...newIngredient, quantity: newValue })
                                            }
                                        }}
                                        required
                                        feedbackInvalid='Please enter valid quantity.'
                                    />
                                </CCol>
                            </CRow>
                            <CRow className="mb-4">
                                <CSelect
                                    label="Unit"
                                    className='d-flex'
                                    labelClassName='w-50'
                                    options={unitOptions}
                                    value={newIngredient.unit}
                                    onChange={(value) => setNewIngredient({ ...newIngredient, unit: value })}
                                    required={true}
                                    errorMessage='Unit is required.'
                                />
                            </CRow>
                        </div>
                        <div className="d-flex button-container p-jc-end justify-content-end">
                            <div className='d-flex'>
                                    <Button onClick={handleIngredientClose} fullWidth variant="contained" color="inherit" >
                                        Cancel
                                    </Button>
                                    <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                                        Submit
                                    </Button>
                            </div>
                        </div>
                    </CForm>
                </Dialog>
            )}
            <Dialog
                draggable={false}
                header={`${productVisible ? 'Create Product' : 'Edit Product'}`}
                visible={productVisible || (editMode && editProductId !== null)}
                style={{ width: `${visibleAdvancedOptions ? "57vw" : "35vw"}` }}
                onHide={handleClose}
            >
                <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                    <div className='fields-container' ref={dialogContentRef} style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
                        <CRow>
                            <CCol>
                                <CRow className="mb-4 mt-3">
                                    <CInput
                                        label="Name"
                                        type="text"
                                        className='d-flex'
                                        labelClassName='w-50'
                                        value={productDetails.name}
                                        onChange={(value) => setProductDetails({ ...productDetails, name: value })}
                                        required={true}
                                        errorMessage='Name is required.'
                                    />
                                </CRow>
                                <CRow className="mb-4 mt-3">
                                    <div className='d-flex'>
                                        <div className='w-50'>
                                            <CFormLabel>SKU <span className="text-danger">*</span></CFormLabel>
                                        </div>
                                        <div className='w-100'>
                                            <CFormInput
                                                type="text"
                                                value={productDetails.sku}
                                                minLength={8}
                                                maxLength={8}
                                                onChange={(e) => setProductDetails({ ...productDetails, sku: e.target.value })}
                                                required={true}
                                                feedbackInvalid='Please enter a SKU with 8 characters.'
                                                className={'is_not_validated'}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </CRow>
                                <CRow className="mb-4">
                                    <CInput
                                        label="Kitchen Name"
                                        type="text"
                                        className='d-flex'
                                        labelClassName='w-50'
                                        value={productDetails.kitchen_name}
                                        onChange={(value) => setProductDetails({ ...productDetails, kitchen_name: value })}
                                    />
                                </CRow>
                                <CRow className="mb-4">
                                    <CategorySelection
                                        className='d-flex'
                                        labelClassName='w-50'
                                        value={productDetails.category_id}
                                        onChange={(value) => setProductDetails({ ...productDetails, category_id: value })}
                                        multiSelect={false}
                                        required={true}
                                        error={categoryValidated}
                                    />
                                </CRow>
                                <CRow className="mb-4">
                                    <div className='d-flex'>
                                        <div className='w-50'>
                                            <CFormLabel className="form-label">Price <span className="text-danger">*</span></CFormLabel>
                                        </div>
                                        <div className='w-100'>
                                            <CInputGroup className='w-100'>
                                                <CInputGroupText id="basic-addon1">
                                                    {currency}
                                                </CInputGroupText>
                                                <CFormInput
                                                    type="number"
                                                    step="any"
                                                    min={0}
                                                    value={productDetails.price}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        if (newValue >= 0) {
                                                            setProductDetails({ ...productDetails, price: newValue })
                                                        }
                                                    }}
                                                    required
                                                    feedbackInvalid='Price is required.'
                                                />
                                            </CInputGroup>
                                        </div>
                                    </div>
                                </CRow>
                                <CRow className="mb-4">
                                    <div className='d-flex'>
                                        <div className='w-50'>
                                            <CFormLabel className="form-label w-100">Cost tax excl. <span className="text-danger">*</span></CFormLabel>
                                        </div>
                                        <div className='w-100'>
                                            <CInputGroup>
                                                <CInputGroupText id="basic-addon1">
                                                    {currency}
                                                </CInputGroupText>
                                                <CFormInput
                                                    type="number"
                                                    step="any"
                                                    min={0}
                                                    value={productDetails.cost_price}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        if (newValue >= 0) {
                                                            setProductDetails({ ...productDetails, cost_price: newValue })
                                                        }
                                                    }}
                                                    required
                                                    feedbackInvalid='Cost price is required.'
                                                />
                                            </CInputGroup>
                                        </div>
                                    </div>
                                </CRow>
                                <CRow className='mb-4'>
                                    <ModifierSelection
                                        className='d-flex'
                                        labelClassName='w-50'
                                        value={productDetails.modifiers}
                                        onChange={(value) => setProductDetails({ ...productDetails, modifiers: value })}
                                    />
                                </CRow>
                                <CRow className="mb-4">
                                    <CSelect
                                        label="Price Type"
                                        className='d-flex'
                                        labelClassName='w-50'
                                        options={productTypes}
                                        value={productDetails.product_type}
                                        onChange={(value) => setProductDetails({ ...productDetails, product_type: value })}
                                    />
                                </CRow>
                                <CRow className="mb-4">
                                    <div className='d-flex'>
                                        <div className='w-50'>
                                            <CFormLabel>Type <span className="text-danger">*</span></CFormLabel>
                                        </div>
                                        <div className='d-flex w-100'>
                                            <CFormCheck
                                                className='me-4'
                                                type="radio"
                                                name="sizeOptions"
                                                id="sizeSmall"
                                                value="small"
                                                checked={productDetails.type === 'food'}
                                                onChange={() => setProductDetails({ ...productDetails, type: 'food' })}
                                                label="Food"
                                                required
                                            />
                                            <CFormCheck
                                                type="radio"
                                                name="sizeOptions"
                                                id="sizeRegular"
                                                value="regular"
                                                checked={productDetails.type === 'beverage'}
                                                onChange={() => setProductDetails({ ...productDetails, type: 'beverage' })}
                                                label="Beverage"
                                                required
                                            />
                                        </div>
                                    </div>
                                </CRow>
                                <CRow className='mb-4'>
                                    <CCol lg={4}>
                                        <CFormLabel className="form-label">Allow Refund</CFormLabel>
                                    </CCol>
                                    <CCol lg={8} className="custom-checkbox px-1">
                                        <Checkbox
                                            checked={productDetails.refund === 1}
                                            onChange={(event) => setProductDetails({ ...productDetails, refund: event.target.checked ? 1 : 0 })}
                                        />
                                    </CCol>
                                </CRow>
                                <CRow className='mb-4'>
                                    <CCol lg={4}>
                                        <CFormLabel className="form-label">Visible</CFormLabel>
                                    </CCol>
                                    <CCol lg={8} className="custom-checkbox px-1">
                                        <Checkbox
                                            checked={productDetails.visible === 1}
                                            onChange={(event) => setProductDetails({ ...productDetails, visible: event.target.checked ? 1 : 0 })}
                                        />
                                    </CCol>
                                </CRow>
                                <CRow className='mb-4'>
                                    <CCol lg={4}>
                                        <CFormLabel className="form-label">Advanced Options</CFormLabel>
                                    </CCol>
                                    <CCol lg={8} className='custom-checkbox px-1'>
                                        <Checkbox
                                            checked={visibleAdvancedOptions === true}
                                            onChange={(event) => setVisibleAdvancedOptions(event.target.checked ? true : false)}
                                        />
                                    </CCol>
                                </CRow>
                                <CRow className="mb-3">
                                    <CCol lg={4}>
                                        <CFormLabel className="form-label">Image</CFormLabel>
                                    </CCol>
                                    <CCol lg={8} style={{ position: 'relative' }} className='px-1'>
                                        <input type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} id="fileInput" />
                                        <label htmlFor="fileInput">
                                            <Card
                                                className="create-card"
                                                header={productDetails.image ? <LazyLoadImage src={productDetails.image || 'defaultImageURL'} alt="Product" className='create-img' /> :
                                                    <Icon icon="mdi:food-outline" style={{ color: "black" }} height={85} width={100} />}
                                            />
                                        </label>
                                        {
                                            productDetails.image &&
                                            <Icon
                                                icon="mdi:close"
                                                className='close-btn'
                                                height={15}
                                                width={15}
                                                onClick={() => setProductDetails({ ...productDetails, image: '' })}
                                            />
                                        }
                                    </CCol>
                                </CRow>
                            </CCol>
                            {visibleAdvancedOptions &&
                                <CCol>
                                    <CRow className="mb-4 mt-3">
                                        <CInput
                                            label="Barcode"
                                            type="text"
                                            className='d-flex'
                                            labelClassName='w-50'
                                            value={productDetails.barcode}
                                            onChange={(value) => setProductDetails({ ...productDetails, barcode: value })}
                                        />
                                    </CRow>
                                    <CRow className="mb-4">
                                        <div className="d-flex">
                                            <CFormLabel className='w-50 custom-word-break'>Description</CFormLabel>
                                            <CFormTextarea
                                                rows={3}
                                                value={productDetails.description}
                                                onChange={(e) => setProductDetails({ ...productDetails, description: e.target.value })}
                                            />
                                        </div>
                                    </CRow>
                                    <CRow className='mb-4'>
                                        <CCol lg={4}>
                                            <CFormLabel className="form-label custom-label">Enable Stock Management</CFormLabel>
                                        </CCol>
                                        <CCol lg={8} className="custom-checkbox ps-0">
                                            <Checkbox
                                                checked={productDetails.enable === 1}
                                                onChange={(event) => setProductDetails({ ...productDetails, enable: event.target.checked ? 1 : 0 })}
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol lg={4}>
                                            <CFormLabel className="form-label custom-word-break">Ingredients</CFormLabel>
                                        </CCol>
                                        <CCol lg={8} className='px-0'>
                                            <CFormLabel className="form-label link" onClick={() => setIngredientVisible(true)}>+ Choose Ingredients</CFormLabel>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        {/* <CCol lg={12}> */}
                                        {productDetails.ingredients.length > 0 ? (
                                            productDetails.ingredients.map((ingredient) => {
                                                return (
                                                    <div key={ingredient.id}>
                                                        <Card
                                                            header={
                                                                <div className='d-flex w-100'>
                                                                    <div className='ingridient-left-container' title={ingredient.id.value ? ingredient.id.label : 'Unknown Ingredient'}>
                                                                        <div className='new_ingridient_name'>
                                                                            {ingredient.id.value ? ingredient.id.label : 'Unknown Ingredient'}
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className='d-flex ingridient-right-container'> */}
                                                                    <div className='ingridient-quntity' title={`${ingredient.quantity}${ingredient.unit}`}>
                                                                        {ingredient.quantity}
                                                                        {ingredient.unit}
                                                                    </div>
                                                                    <div className='ingridient-action'>
                                                                        <Icon icon="ic:outline-edit" style={{ color: 'black' }} className='me-1' onClick={() => handleEditIngrediants(ingredient.id)} title='Edit' />
                                                                        <Icon icon="material-symbols:delete-outline" style={{ color: 'black' }} onClick={() => handleIngredientDelete(ingredient.id)} title='Delete' />
                                                                    </div>
                                                                    {/* </div> */}
                                                                </div>}
                                                            className="ingredient-list-card"
                                                        />
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            ''
                                        )}
                                        {/* </CCol> */}
                                    </CRow>
                                </CCol>
                            }
                        </CRow>
                    </div>
                    <div className={`button-container d-flex ${(editMode && editProductId && canDelete) ? 'justify-content-between' : 'justify-content-end'}`}>
                        {
                            (editMode && editProductId && canDelete) && (
                                <div>
                                    <Button color='error' variant="contained" onClick={handleDelete} >
                                        Archive
                                    </Button>
                                </div>
                            )
                        }
                        <div className='d-flex'>
                            <Button onClick={handleClose} fullWidth variant="contained" color="inherit" >
                                Cancel
                            </Button>
                            {((!editMode && canCreate) || (editMode && canUpdate)) && (
                                <Button fullWidth variant="contained" color="primary" type="submit" className="ms-3">
                                    Submit
                                </Button>
                            )}
                        </div>
                    </div>
                </CForm>
            </Dialog>
        </>
    )
}

export default AddProduct
